import { extractCertificateExpiry } from "./extractCertificateExpiry";

export interface ParsedSamlMetadata {
  issuer: string | null;
  signOnUrl: string | null;
  certificateExpiry: string | null; // "Friday, June 25, 2027"
}

export const parseSamlMetadata = (xmlString: string): ParsedSamlMetadata => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "application/xml");

  const parseError = xmlDoc.querySelector("parsererror");
  if (parseError) {
    throw new Error("Invalid XML file");
  }

  // Issuer (Entity ID)
  const entityDescriptor = xmlDoc.querySelector("EntityDescriptor");
  const issuer = entityDescriptor?.getAttribute("entityID") || null;

  // Sign-On URL
  const ssoServices = xmlDoc.querySelectorAll(
    "IDPSSODescriptor SingleSignOnService"
  );
  let signOnUrl: string | null = null;
  ssoServices.forEach((service) => {
    const binding = service.getAttribute("Binding");
    const location = service.getAttribute("Location");
    if (binding?.includes("HTTP-POST")) {
      signOnUrl = location;
    } else if (!signOnUrl && binding?.includes("HTTP-Redirect")) {
      signOnUrl = location;
    }
  });

  // Certificate Expiry
  let certificateExpiry: string | null = null;
  const cert =
    xmlDoc.querySelector("IDPSSODescriptor KeyDescriptor X509Certificate") ||
    xmlDoc.querySelector("X509Certificate");

  if (cert?.textContent) {
    const expiryDate = extractCertificateExpiry(cert.textContent.trim());
    if (expiryDate) {
      certificateExpiry = expiryDate.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }
  }

  return { issuer, signOnUrl, certificateExpiry };
};
